import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const JohnDeereIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.johnDeereIcon}`}
        data-testid={testId}
        fill='none'
        height='20'
        viewBox='0 0 24 20'
        width='24'
        xmlns='http://www.w3.org/2000/svg'>
        <path d='M12 0C5.373 0 0 4.477 0 10s5.373 10 12 10 12-4.477 12-10S18.627 0 12 0zm0 18.5c-5.238 0-9.5-3.806-9.5-8.5S6.762 1.5 12 1.5s9.5 3.806 9.5 8.5-4.262 8.5-9.5 8.5zm-1.5-12h3v7h-3V6.5z' />
    </svg>
);

export default JohnDeereIcon;
